<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout column align-center justify-center>
          <p>
            <img
                :src="require('../assets/FullNameLogo.png')"
                alt="Scorebook"
                style="width:25vw;max-width:150px;">
          </p>
          <div style="font-size: 100pt">
            <span>4</span>
            <span><img
                :src="require('../assets/sad.svg')"
                style="max-height:110px;"
                alt="sad face"></span>
            <span>4</span>
          </div>
          <h2 class="mb-5">Oops! the page you were looking for doesn't exist.</h2>

          <v-btn
              round
              color="warning"
              @click="$router.push('/home')"
          >
            Go to Home
          </v-btn>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
    export default {
        name: "Error404"
    }
</script>

<style scoped>

</style>
